import { DescriptionPage_CourseType as DescriptionPageCourseType } from '__generated__/graphql-types';

import { getGuidedProjectFaqs } from 'bundles/unified-description-page-common/data/faqs/guidedProjectFaqs';
import { getProjectFaqs } from 'bundles/unified-description-page-common/data/faqs/projectFaqs';

// Guided project/project pages use hardcoded FAQs that change depending on product type and if product provides a full discount.
const getProjectPageFaqs = (courseType: DescriptionPageCourseType, hasFullDiscount?: boolean) => {
  if (courseType === DescriptionPageCourseType.Project) {
    return getProjectFaqs(hasFullDiscount);
  } else {
    return getGuidedProjectFaqs(hasFullDiscount);
  }
};

export default getProjectPageFaqs;
